import { useCallback } from 'react'
import { connect } from 'formik'
import {
  SectionItem,
  SplitButtonGroup,
  ISplitButtonGroupItem,
} from '@features/shift-post-v2/components'
import { useSelector } from 'react-redux'
import { useTemplate } from '@src/features/shift-post-v2/steps/shift-details-step/components/select-template-section/hooks/useTemplate'
import { selectCurrentTemplates } from '@src/data/Templates/selectors'
import { URLManager } from 'helpers/URLManager'
import { ISelectTemplateSectionProps } from './select-template-section.types'
import { StyledText } from './select-template-section.styles'

export const SelectTemplateSection = connect<ISelectTemplateSectionProps>(({ formik }) => {
  const templates = useSelector(selectCurrentTemplates)
  // get the template_id from the url
  const urlManager = new URLManager()
  const templateIdParam = urlManager.getParam('template_id')

  const { updateFormikWithTemplateData } = useTemplate(formik, true)

  const items = templates.map((template) => ({
    id: template.id.toString(),
    label: template.name,
    value: template.id.toString(),
    isSelected: template.id === Number(templateIdParam), // compare with numeric id
  }))

  const handleSelect = useCallback(
    (item: ISplitButtonGroupItem<string>) => {
      const selectedTemplateId = Number(item.id)

      // Sync selected template with url query param
      const urlManager = new URLManager()
      urlManager.setParamsAndPush({ template_id: selectedTemplateId })

      // Find the full template object
      const template = templates.find((t) => t.id === selectedTemplateId)
      if (template) {
        updateFormikWithTemplateData(template)
      }
    },
    [templates, updateFormikWithTemplateData]
  )

  return (
    <SectionItem title='Select a template' hasEdit={false}>
      <StyledText>You can edit and save changes in the selected template at any time</StyledText>
      <SplitButtonGroup
        items={items}
        lines={2}
        onSelect={handleSelect}
        sortOnSelect
        maxLabelLength={35}
        mt='14px'
      />
    </SectionItem>
  )
})
